<template>
  <div class="api-bar-char-cla">
    <chartTop v-model="time" :title="$t('statistics.apiSort')"></chartTop>
    <div class="statistics-chart-box-cla" id="aipbarChart">
      <zkLoading style="margin-top:0" v-show="showLoad"></zkLoading>
    </div>
  </div>
</template>

<script>
import chartTop from './chartTop'
import { getLastTime } from '@/utils/utils.js'
import { getStatistic } from '@/services/statisticsApi.js'
import { getOptionConfig } from './apiBarChar.js'

var echarts = require('echarts')
export default {
  data() {
    return {
      time: 30,
      timeRange: [],
      paihang: [],
      showLoad: false,
      barChart: null
    }
  },
  components: {
    chartTop
  },
  watch: {
    time: {
      handler(newValue, oldValue) {
        if (newValue === 90) {
          // 最近三个月
          this.timeRange = getLastTime('months', 3)
        } else if (newValue === 30) {
          // 最近一个月个月
          this.timeRange = getLastTime('months', 1)
        } else {
          // 最近一周
          this.timeRange = getLastTime('days', 7)
        }
        this.getStatistic()
      },
      immediate: true
    }
  },
  mounted() {
    let that = this
    window.goDetail = function() {
      that.$router.push({
        name: 'statisticsCallDetails',
        params: { time: that.time }
      })
    }
  },
  methods: {
    getStatistic() {
      let params = {
        startTime: this.timeRange[0],
        endTime: this.timeRange[1],
        topCount: 10,
        appCode: 'DBS'
      }
      this.showLoad = true
      getStatistic(params)
        .then(data => {
          if (data.code === '00000000') {
            this.paihang = data.payload.data
            this.getOption()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.showLoad = false
        })
    },
    getOption() {
      let lang = {}
      let option = getOptionConfig(this.paihang, lang, this)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(document.getElementById('aipbarChart'))
        this.barChart.on('click', function(params) {})
      }
      this.barChart.setOption(option, true)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.api-bar-char-cla {
  height: @statisticsChartHeight;
  width: 50%;
  background-color: #ffffff;
  border-radius: 4px;
  position: relative;
}
@media screen and (max-width: 980px) {
  .api-bar-char-cla {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/apiStatistics/apiBarChar.vue